import { useState } from 'react';
import {
    Icon,
    ResponsivePopover,
    Text
} from '@ui5/webcomponents-react';

export function EstInfoButton(props) {

    const [popoverIsOpen, setPopoverIsOpen] = useState(false);

    return (
        <>

            <Icon
                id= {props.iconId}
                style={props.iconStyle}
                interactive name="information" onClick={() => {
                    setPopoverIsOpen(!popoverIsOpen);
                }}

                design='Information'></Icon>


            <ResponsivePopover
                headerText={props.header}
                opener={props.iconId}
                open={popoverIsOpen}
                onAfterClose={() => {
                    setPopoverIsOpen(false);
                }}
            >
                <Text>
                    {props.text}
                </Text>
            </ResponsivePopover>
        </>
    );
};
